module.exports = __webpack_public_path__ + "img/sberbank.b3e618f9.svg";